import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'edit-recommendation-modal',
  templateUrl: 'edit-recommendation.component.html',
  styleUrls: ['edit-recommendation.component.scss'],
  standalone: false,
})

export class EditRecommendationComponent {
  recommendationText = signal('');
  readonly = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<EditRecommendationComponent>,) {
    if (data && data.text) {
      this.recommendationText.set(data.text);
    }
    this.readonly = data.readonly;
  }

  editRecommendation(){
    this.dialogRef.close(this.recommendationText());
  }
}
